import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Flatpickr from "react-flatpickr";
import BreadCrumb from 'Common/BreadCrumb';
import { Link } from 'react-router-dom';
import { Dropdown } from 'Common/Components/Dropdown';
import TableContainer from 'Common/TableContainer';
import moment from "moment";
import Select from 'react-select';

// Icons
import { Search, Trash2, Plus, MoreHorizontal, FileEdit } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import DeleteModal from 'Common/DeleteModal';

// Images

// react-redux
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  onAddRewardPoint,
  onDeleteRewardPoint,
  onGetRewardPointList,
  onUpdateRewardPoint,
} from 'slices/thunk';
import { ToastContainer } from 'react-toastify';
import filterDataBySearch from 'Common/filterDataBySearch';
import { currencyFormatter } from '../../helpers/formatter';
import { doGetCampaignList, RewardPointModel } from '../../services/reward.service';
import { CustomerModel, doListCustomer } from '../../services/customer.service';
import { CampaignModel } from '../../services/maintenance.service';


const RewardPointPage = () => {
  const dispatch = useDispatch<any>();

  const selectDataList = createSelector(
    (state: any) => state.Reward,
    (reward) => ({
      rewardPointList: reward.rewardPointList
    })
  );

  const { rewardPointList } = useSelector(selectDataList);
  const [rewardPoint, setRewardPoint] = useState<RewardPointModel[]>([]);
  const [eventData, setEventData] = useState<any>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [customerList, setCustomerList] = useState<CustomerModel[]>([]);
  const [customerDropdown, setCustomerDropdown] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [campaignList, setCampaignList] = useState<CampaignModel[]>([]);
  const [campaignDropdown, setCampaignDropdown] = useState<any[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  // Get Data
  useEffect(() => {
    dispatch(onGetRewardPointList())
    handleGetCustomerList()
    handleGetCampaignList()
  }, [dispatch])

  useEffect(() => {
    setRewardPoint(rewardPointList)
  }, [rewardPointList])

  function handleGetCustomerList() {
    doListCustomer(0).then((res: any) => {
      setCustomerList(res.data)
      setCustomerDropdown(res.data.map((item: CustomerModel) => ({ value: item.userId, label: item.name+' : '+item.phoneNo })))
    })
  }

  function handleGetCampaignList() {
    doGetCampaignList().then((res: any) => {
      setCampaignList(res)
      setCampaignDropdown(res.map((item: CampaignModel) => ({ value: item.campaignId, label: item.name })))
    })
  }

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.serviceId) {
      setEventData(cell);
    }
  };

  const handleDelete = () => {
    if (eventData) {
      dispatch(onDeleteRewardPoint(eventData.serviceId));
      setDeleteModal(false);
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      rewardPointsId: (eventData && eventData.rewardPointsId) || '',
      projectId: (eventData && eventData.projectId) || '',
      userId: (eventData && eventData.userId) || '',
      totalPurchase: (eventData && Number(eventData.totalPurchase)) || '',
      points: (eventData && Number(eventData.points)) || '',
      rewardType: (eventData && eventData.rewardType) || '',
      sourceId: (eventData && eventData.sourceId) || '',
      sourceType: (eventData && eventData.sourceType) || '',
      description: (eventData && eventData.description) || '',
      expiredAt: (eventData && eventData.expiredAt) || '',
    },
    validationSchema: Yup.object({
      rewardPointsId: Yup.string().optional(),
      userId: Yup.string().required("Please Enter User Id"),
      totalPurchase: Yup.number().required("Please Enter Total Purchase"),
      points: Yup.number().required("Please Enter Points"),
      rewardType: Yup.string().required("Please Enter Reward Type"),
      sourceId: Yup.string().optional(),
      sourceType: Yup.string().required("Please Enter Source Type"),
      description: Yup.string().optional(),
      expiredAt: Yup.date().required("Please Enter Expired At"),
    }),

    onSubmit: (values) => {
      const data = {
        ...values,
      };
      if (isEdit) {
        dispatch(onUpdateRewardPoint(data));
      } else {
        delete data.rewardPointsId;
        dispatch(onAddRewardPoint(data));
      }
      toggle();
    },
  });

  const rewardTypeSelect = [
    { value: 'Purchase', label: 'Purchase' },
    { value: 'Redemption', label: 'Redemption' },
  ];

  const sourceTypeSelect = [
    { value: 'campaign', label: 'Campaign' },
    { value: 'reward', label: 'Reward' },
    { value: 'point_history', label: 'Point History' },
  ];

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      // setSelectedImage('');
    } else {
      setShow(true);
      setEventData("");
      // setSelectedImage('');
      validation.resetForm();
    }
  }, [show, validation]);

  // Search Data
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ['code', 'title', 'serviceType'];
    filterDataBySearch(rewardPointList, search, keysToSearch, setRewardPoint);
  };

  const columns = useMemo(() => [
    {
      header: (
        <div className="flex items-center h-full">
          <input id="CheckboxAll" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
        </div>
      ),
      enableSorting: false,
      id: "checkAll",
      cell: (cell: any) => {
        return (
          <div className="flex items-center h-full">
            <input id="Checkbox1" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
          </div>
        );
      }
    },
    {
      header: "Reward Date",
      accessorKey: "createdAt",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">
            <span>{moment(cell.getValue()).format("DD MMM YYYY")}</span>
          </div>
        </div>
      ),
    },
    {
      header: "Customer Name",
      accessorKey: "user",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="grow">
            <h6 className="mb-1">{cell.row.original.user?.name}</h6>
          </div>
        </div>
      ),
    },
    {
      header: "Point",
      accessorKey: "points",
      enableColumnFilter: false
    },
    {
      header: "Total Purchase",
      accessorKey: "totalPurchase",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <span>{currencyFormatter(cell.getValue())}</span>
      )
    },
    {
      header: "Action",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <Dropdown className="relative">
          <Dropdown.Trigger className="flex items-center justify-center w-[30px] h-[30px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20" id={cell.row.original.serviceId}>
            <MoreHorizontal className="w-3 h-3" />
          </Dropdown.Trigger>
          <Dropdown.Content placement="right-end" className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md min-w-[10rem] dark:bg-zink-600" aria-labelledby={cell.row.original.serviceId}>
            <li>
              <Link data-modal-target="addUserModal" className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!"
                onClick={() => {
                  const data = cell.row.original;
                  handleUpdateDataClick(data);
                }}>
                <FileEdit className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Edit</span></Link>
            </li>
            {
              cell.row.original.status === 'active' &&
              <li>
                <Link className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!" onClick={() => {
                  const data = cell.row.original;
                  onClickDelete(data);
                }}><Trash2 className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Delete</span></Link>
              </li>
            }
          </Dropdown.Content>
        </Dropdown>
      ),
    }
  ], [])

  const handleChange = (selectedOption: any) => {
    if (selectedOption.value === 'Select Status' || selectedOption.value === 'Hidden') {
      setRewardPoint(rewardPointList);
    } else {
      const filteredPointHistories = rewardPointList.filter((data: any) => data.status === selectedOption.value);
      setRewardPoint(filteredPointHistories);
    }
  };

  return (
    <React.Fragment>
      <BreadCrumb title='Reward' pageTitle='Reward Point' />
      <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDelete} />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <div className="card" id="usersTable">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">Reward Point History</h6>
                <div className="shrink-0">
                  <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={toggle}><Plus className="inline-block w-4 h-4" />
                    <span className="align-middle">Add Point</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-2">
                    <input type="text" className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Search for name, email, phone number etc..." autoComplete="off" onChange={(e) => filterSearchData(e)} />
                    <Search className="inline-block w-4 h-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                  <div className="xl:col-span-2">
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={customerDropdown}
                      isSearchable={false}
                      onChange={(event: any) => handleChange(event)}
                      id="choices-single-default"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              {rewardPoint && rewardPoint.length > 0 ?
                <TableContainer
                  isPagination={true}
                  columns={(columns || [])}
                  data={(rewardPoint || [])}
                  customPageSize={10}
                  divclassName="-mx-5 -mb-5 overflow-x-auto"
                  tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                  theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                  thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                  tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                  PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                />
                :
                (<div className="noresult">
                  <div className="py-6 text-center">
                    <Search className="w-6 h-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                    <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 199+ users We did not find any users for you search.</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
          <Modal.Title className="text-16">{!!isEdit ? "Update Point" : "Add Point"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form action="#!" onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>
            <div className="mb-3">
              <label htmlFor="userIdInput" className="inline-block mb-2 text-base font-medium">Customer</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={customerDropdown}
                isSearchable={false}
                name="userId"
                id="userIdInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`userId`, selectedOption?.value)
                }}
                value={customerDropdown.find(customer => { return customer.value === validation.values.userId })}
              />
              {validation.touched.userId && validation.errors.userId ? (
                <p className="text-red-400">{validation.errors.userId}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="totalPurchaseInput" className="inline-block mb-2 text-base font-medium">Total Purchase</label>
              <input className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                type="text"
                id="totalPurchaseInput"
                placeholder="Enter Total Purchase"
                name="totalPurchase"
                onChange={validation.handleChange}
                value={validation.values.totalPurchase || ""}
              />
              {validation.touched.totalPurchase && validation.errors.totalPurchase ? (
                <p className="text-red-400">{validation.errors.totalPurchase}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="pointsInput" className="inline-block mb-2 text-base font-medium">Points</label>
              <input className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                type="text"
                id="pointsInput"
                placeholder="Enter Points"
                name="points"
                onChange={validation.handleChange}
                value={validation.values.points || ""}
              />
              {validation.touched.points && validation.errors.points ? (
                <p className="text-red-400">{validation.errors.points}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="rewardTypeInput" className="inline-block mb-2 text-base font-medium">Reward Type</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={rewardTypeSelect}
                isSearchable={false}
                name="rewardType"
                id="rewardTypeInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`rewardType`, selectedOption?.value)
                }}
                value={rewardTypeSelect.find(rewardType => { return rewardType.value === validation.values.rewardType })}
              />
              {validation.touched.rewardType && validation.errors.rewardType ? (
                <p className="text-red-400">{validation.errors.rewardType}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="sourceTypeInput" className="inline-block mb-2 text-base font-medium">Source Type</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={sourceTypeSelect}
                isSearchable={false}
                name="sourceType"
                id="sourceTypeInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`sourceType`, selectedOption?.value)
                }}
                value={sourceTypeSelect.find(sourceType => { return sourceType.value === validation.values.sourceType })}
              />
              {validation.touched.sourceType && validation.errors.sourceType ? (
                <p className="text-red-400">{validation.errors.sourceType}</p>
              ) : null}
            </div>
            {
              validation.values.sourceType === 'campaign' &&
              <div className="mb-3">
                <label htmlFor="sourceIdInput" className="inline-block mb-2 text-base font-medium">Source</label>
                <Select
                  className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  options={campaignDropdown}
                  isSearchable={false}
                  name="sourceId"
                  id="sourceIdInput"
                  onChange={selectedOption => {
                    validation.setFieldValue(`sourceId`, selectedOption?.value)
                  }}
                  value={campaignDropdown.find(campaign => { return campaign.value === validation.values.sourceId })}
                />
                {validation.touched.sourceId && validation.errors.sourceId ? (
                  <p className="text-red-400">{validation.errors.sourceId}</p>
                ) : null}
              </div>
            }
            <div className="mb-3">
              <label htmlFor="descriptionInput" className="inline-block mb-2 text-base font-medium">Description</label>
              <textarea id="descriptionInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                rows={5}
                placeholder="Enter Description"
                name="description"
                onChange={validation.handleChange}
                value={validation.values.description || ""}
              />
              {validation.touched.description && validation.errors.description ? (
                <p className="text-red-400">{validation.errors.description}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="expiredAtInput" className="inline-block mb-2 text-base font-medium">Expired At</label>
              <Flatpickr
                id="expiredAtInput"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={{
                  enableTime: true,
                  dateFormat: "d M, Y H:i",
                }}
                placeholder='Select Date'
                name='expiredAt'
                onChange={(date: any) => {
                  validation.setFieldValue("expiredAt", date[0])
                }}
                value={validation.values.expiredAt || ''}
              />
              {validation.touched.expiredAt && validation.errors.expiredAt ? (
                <p className="text-red-400">{validation.errors.expiredAt}</p>
              ) : null}
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="reset"
                data-modal-close="addDocuments"
                className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {!!isEdit ? "Update Point" : "Add Point"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default RewardPointPage;
